// Banner.jsx
import React from "react";
import '../../../assets/css/user/general/simpleBanner.css';

const SimpleBanner = ({ breadcrumbs = [], title, subtitle }) => {
  return (
    <div className="banner-container">
      {/* Decorative Elements */}
      <div style={{ height: "100%", width: "100%", backgroundColor:"rgba(15,75,128,0.9)",position:"absolute" }}></div>
      {/* Content Container */}
      <div className="banner-content">
        {/* Breadcrumb Navigation */}
        <nav className="breadcrumb-nav" aria-label="Breadcrumb">
          <div className="breadcrumb-list">
            {breadcrumbs.map((crumb, index) => (
              <React.Fragment key={index}>
                {index > 0 && (
                  <svg
                    className="breadcrumb-separator"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                )}
                <a
                  href={crumb.href}
                  className={`breadcrumb-link ${crumb.current ? "active" : ""}`}
                  aria-current={crumb.current ? "page" : undefined}
                >
                  {crumb.icon && (
                    <svg
                      className="breadcrumb-icon"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                      />
                    </svg>
                  )}
                  {crumb.label}
                </a>
              </React.Fragment>
            ))}
          </div>
        </nav>

        {/* Banner Title */}
        <div className="banner-title-section">
          <h1 className="banner-title">{title}</h1>
          <p className="banner-subtitle">{subtitle}</p>
        </div>
      </div>

      {/* Bottom Gradient Fade */}
      <div className="banner-bottom-fade"></div>
    </div>
  );
};

export default SimpleBanner;
